<template>

    <m-edit1/>

    <m-dashboard-products-300 v-bind='{...{},...{}}' :style='""' class="" ></m-dashboard-products-300>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardProducts300 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Dashboard/DashboardProducts300/DashboardProducts300';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardProducts300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
